import { render, staticRenderFns } from "./Navmenu.vue?vue&type=template&id=50a6ef8f&scoped=true&"
import script from "./Navmenu.vue?vue&type=script&lang=js&"
export * from "./Navmenu.vue?vue&type=script&lang=js&"
import style0 from "./Navmenu.vue?vue&type=style&index=0&id=50a6ef8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a6ef8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VSpacer,VToolbar,VToolbarTitle})
